import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { push } from 'react-router-redux'
import Linkify from 'react-linkify'

import classNames from './Login.css'
import { login } from '../redux/auth'
import { fetchAlbums } from '../redux/albums'
import { fetchPlaylists } from '../redux/playlists'
import LoadingSpinner from '../components/LoadingSpinner'

function Login ({ handleSubmit, submitting, loginError, dirty }) {
  return (
    <div className={classNames.wrapper}>
      <form onSubmit={handleSubmit} className={classNames.form}>
        <h1 className={classNames.heading}>Blayzr</h1>
        <Field component={Input} type='email' name='email' props={{ label: 'Email' }} />
        <Field component={Input} type='password' name='password' props={{ label: 'Password' }} />
        {loginError &&
          <div className={classNames.error}>
            There was an error logging in
            {(loginError.statusText || loginError.message) &&
              <Linkify>: {loginError.message || loginError.statusText}</Linkify>
            }
          </div>
        }
        <button type='submit' disabled={submitting || !dirty} className={classNames.submit}>
          Log in
        </button>
        <LoadingSpinner white show={submitting} />
      </form>
    </div>
  )
}

function Input (props) {
  return (
    <label>
      {props.label}
      <input {...props} />
      {props.touched && props.error &&
        <div className={classNames.error}>
          {props.error}
        </div>
      }
    </label>
  )
}

function validate (values) {
  const error = {}
  if (!values.email) {
    error.email = 'Please enter an email address'
  }
  if (!values.password) {
    error.password = 'Please enter a password'
  }
  return error
}

const mapStateToProps = ({ auth }) => ({
  authenticating: auth.authenticating,
  loginError: auth.error
})

// redux-form uses onSubmit, but passes handleSubmit down to the decorated component
const mapDispatchToProps = (dispatch, props) => ({
  onSubmit: data => {
    return dispatch(login(data.email, data.password))
      .then(() => {
        if (props.location.query.redirect === '/') {
          return Promise.all([
            dispatch(fetchAlbums()),
            dispatch(fetchPlaylists())
          ])
        }
        return true
      }).then(() => {
        dispatch(push(props.location.query.redirect))
      })
  }
})

const LoginForm = reduxForm({ form: 'login', validate })(Login)

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)



// WEBPACK FOOTER //
// ./src/pages/Login.js